import { useEffect, useState } from 'react';

import { TimerIcon } from 'lucide-react';

import { cn } from '../../lib/utils';

export type QuizPlayerTimerProps = React.ComponentProps<'div'> & {
  timeLimit: number;
  onTimeUp?: () => void;
  isActive?: boolean;
};

export function QuizPlayerTimer({
  timeLimit,
  onTimeUp = () => {},
  isActive,
  className,
  ...others
}: QuizPlayerTimerProps) {
  const [timeLeft, setTimeLeft] = useState(timeLimit);

  useEffect(() => {
    setTimeLeft(timeLimit);
  }, [timeLimit]);

  useEffect(() => {
    if (!isActive) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onTimeUp();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isActive, onTimeUp]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div
      {...others}
      data-slot="quiz-player-timer"
      className={cn(
        'flex items-center gap-2 text-muted-foreground text-sm md:text-md',
        { 'text-yellow-500 font-semibold': timeLeft <= 10 },
        { 'text-destructive font-semibold': timeLeft === 0 },
        className
      )}
    >
      <TimerIcon size={16} />
      <span>
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </span>
    </div>
  );
}
